import { Item, Layout } from "@/dto/item";
import { SingleProductDescriptionFocused } from "@/components/singleProduct/singleProductDescriptionFocused";
import { SingleProductImageFocused } from "@/components/singleProduct/singleProductImageFocused";
import {
  TEMPLATE_DESCRIPTION_FOCUSED,
  TEMPLATE_IMAGE_FOCUSED,
} from "@/utils/constants";
import { Markers } from '@/dto/marker';

interface MenuItemContentProps {
  readonly item: Item;
  readonly merchantName?: string;
  readonly itemTemplate?: string;
  readonly cardChildren?: React.ReactNode;
  readonly markers?: Markers;
  readonly layout?: Layout;
}

const MenuItemContent = ({
  item,
  merchantName,
  itemTemplate,
  cardChildren,
  layout = "default",
  markers
}: MenuItemContentProps) => (
  <>
    {itemTemplate?.toLowerCase() === TEMPLATE_DESCRIPTION_FOCUSED && (
      <SingleProductDescriptionFocused
        merchantName={merchantName || ""}
        product={item}
        cardChildren={cardChildren}
        layout={layout}
        markers={markers}
      />
    )}
    {itemTemplate?.toLowerCase() === TEMPLATE_IMAGE_FOCUSED && (
      <SingleProductImageFocused
        product={item}
        cardChildren={cardChildren}
        layout={layout}
        markers={markers}
      />
    )}
  </>
);

export default MenuItemContent;
